(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    function initCart() {
      const trigger = document.getElementById('ScUpdateTrigger');
      if (!trigger) return;

      document.querySelectorAll('[data-sc-qty]').forEach((block) => {
        const input = block.querySelector('[data-sc-input]');
        if (!input) return;

        block.querySelectorAll('[data-sc-change]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const dir = parseInt(btn.dataset.scChange, 10);
            const next = Math.max(0, parseInt(input.value, 10) + dir);
            input.value = next;
            trigger.click();
          });
        });
      });
    }

    document.addEventListener('DOMContentLoaded', initCart);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    if (window.SoyesHeaderInitialized) {
      return;
    }

    window.SoyesHeaderInitialized = true;

    function init(root = document) {
      root.querySelectorAll('[data-soyes-header]:not([data-soyes-ready])').forEach((header) => {
        header.dataset.soyesReady = 'true';
        const toggle = header.querySelector('[data-soyes-menu-toggle]');
        const closeButton = header.querySelector('[data-soyes-menu-close]');
        const scrim = header.querySelector('[data-soyes-menu-scrim]');
        const links = header.querySelectorAll('[data-soyes-menu] a');

        function setMenu(open) {
          header.classList.toggle('is-menu-open', open);
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        function setScrolled() {
          const alpha = Math.min(window.scrollY / 160, 1);
          header.style.setProperty('--soyes-header-alpha', alpha.toFixed(3));
          header.classList.toggle('is-scrolled', alpha > 0.02);
        }

        function scrollToTarget(target) {
          const headerHeight = header.getBoundingClientRect().height;
          const targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight;

          window.scrollTo({
            top: Math.max(targetTop, 0),
            behavior: 'smooth',
          });
        }

        function handleSamePageLink(event, link) {
          const url = new URL(link.href, window.location.href);
          const currentPath = `${window.location.pathname}${window.location.search}`;
          const targetPath = `${url.pathname}${url.search}`;

          if (url.origin !== window.location.origin) {
            return;
          }

          if (targetPath !== currentPath) {
            return;
          }

          if (!url.hash) {
            event.preventDefault();
            setMenu(false);
            window.history.pushState(null, '', targetPath);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
          }

          const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));

          if (!target) {
            return;
          }

          event.preventDefault();
          setMenu(false);
          window.history.pushState(null, '', `${targetPath}${url.hash}`);
          window.setTimeout(() => scrollToTarget(target), 230);
        }

        toggle.addEventListener('click', () => setMenu(!header.classList.contains('is-menu-open')));
        closeButton.addEventListener('click', () => setMenu(false));
        scrim.addEventListener('click', () => setMenu(false));
        links.forEach((link) => {
          link.addEventListener('click', (event) => {
            setMenu(false);
            handleSamePageLink(event, link);
          });
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            setMenu(false);
          }
        });

        window.addEventListener('scroll', setScrolled, { passive: true });
        setScrolled();
      });
    }

    document.addEventListener('DOMContentLoaded', () => init(document));
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    init(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (() => {
    if (window.SoyesPasswordInitialized) {
      return;
    }

    window.SoyesPasswordInitialized = true;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function init(root = document) {
      root.querySelectorAll('[data-soyes-password]:not([data-soyes-password-ready])').forEach((section) => {
        section.dataset.soyesPasswordReady = 'true';

        const countdown = section.querySelector('[data-soyes-password-countdown]');

        if (!countdown) {
          return;
        }

        const configuredTarget = new Date(section.dataset.launchTarget);
        const fallbackTarget = new Date('2026-07-01T18:00:00+02:00');
        const target = Number.isNaN(configuredTarget.getTime()) ? fallbackTarget : configuredTarget;

        const parts = {
          days: countdown.querySelector('[data-countdown-days]'),
          hours: countdown.querySelector('[data-countdown-hours]'),
          minutes: countdown.querySelector('[data-countdown-minutes]'),
          seconds: countdown.querySelector('[data-countdown-seconds]'),
        };

        function tick() {
          const diff = Math.max(0, target.getTime() - Date.now());
          const days = Math.floor(diff / 86400000);
          const hours = Math.floor((diff % 86400000) / 3600000);
          const minutes = Math.floor((diff % 3600000) / 60000);
          const seconds = Math.floor((diff % 60000) / 1000);

          parts.days.textContent = pad(days);
          parts.hours.textContent = pad(hours);
          parts.minutes.textContent = pad(minutes);
          parts.seconds.textContent = pad(seconds);
        }

        tick();
        window.setInterval(tick, 1000);
      });
    }

    document.addEventListener('DOMContentLoaded', () => init(document));
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    init(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    function initSp(root) {
      root.querySelectorAll('[data-sp]').forEach((section) => {
        const sid = section.dataset.sp;
        const dataEl = document.getElementById('sp-data-' + sid);
        if (!dataEl) return;

        let variants;
        try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

        // ── Gallery carousel ──────────────────────────────
        const slides = section.querySelector('[data-sp-slides]');
        const slideEls = Array.from(section.querySelectorAll('[data-sp-slide]'));
        const dots = Array.from(section.querySelectorAll('[data-sp-dot]'));
        const prevBtn = section.querySelector('[data-sp-prev]');
        const nextBtn = section.querySelector('[data-sp-next]');

        function getActiveIndex() {
          if (!slides || slides.offsetWidth === 0) return 0;
          return Math.round(slides.scrollLeft / slides.offsetWidth);
        }

        function goToSlide(idx) {
          if (!slides || !slideEls[idx]) return;
          slides.scrollTo({ left: slides.offsetWidth * idx, behavior: 'smooth' });
        }

        function updateDots(idx) {
          dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', () => goToSlide(Math.max(0, getActiveIndex() - 1)));
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', () => goToSlide(Math.min(slideEls.length - 1, getActiveIndex() + 1)));
        }
        dots.forEach((d) => {
          d.addEventListener('click', () => goToSlide(parseInt(d.dataset.spDot, 10)));
        });
        if (slides) {
          slides.addEventListener('scroll', () => updateDots(getActiveIndex()), { passive: true });
        }

        // ── Variant selection ─────────────────────────────
        const priceEl = document.getElementById('SpPrice' + sid);
        const variantInput = document.getElementById('SpVariantId' + sid);
        const addBtn = document.getElementById('SpAddBtn' + sid);
        const radios = Array.from(section.querySelectorAll('.sp__size-radio'));

        function getSelectedOptions() {
          const map = {};
          radios.forEach((r) => {
            if (r.checked) map[parseInt(r.dataset.spOpt, 10)] = r.value;
          });
          return Object.keys(map).sort((a, b) => a - b).map((k) => map[k]);
        }

        function formatMoney(cents) {
          return (cents / 100).toFixed(2).replace('.', ',') + ' €';
        }

        function update() {
          section.querySelectorAll('.sp__size-label').forEach((lbl) => {
            const inp = lbl.querySelector('.sp__size-radio');
            if (inp) lbl.classList.toggle('is-active', inp.checked);
          });

          radios.forEach((r) => {
            if (r.checked) {
              const el = section.querySelector('[data-sp-opt-val="' + r.dataset.spOpt + '"]');
              if (el) el.textContent = r.value;
            }
          });

          const selected = getSelectedOptions();
          const variant = variants.find((v) =>
            v.options.every((o, i) => o === selected[i])
          );
          if (!variant) return;

          if (variantInput) variantInput.value = variant.id;
          if (priceEl) priceEl.textContent = formatMoney(variant.price);

          if (addBtn) {
            const ok = variant.available;
            addBtn.disabled = !ok;
            addBtn.classList.toggle('sp__add-btn--unavailable', !ok);
            addBtn.textContent = ok ? 'In den Warenkorb' : 'Ausverkauft';
          }

          // Scroll gallery to variant's featured image
          if (variant.featured_image) {
            const imgId = variant.featured_image.id;
            const target = slideEls.find((s) => parseInt(s.dataset.spImageId, 10) === imgId);
            if (target) goToSlide(parseInt(target.dataset.spSlide, 10));
          }
        }

        radios.forEach((r) => r.addEventListener('change', update));
      });
    }

    document.addEventListener('DOMContentLoaded', () => initSp(document));
    document.addEventListener('shopify:section:load', (e) => initSp(e.target));
    initSp(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soyes-launch"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.SoyesLaunchInitialized) {
      return;
    }

    window.SoyesLaunchInitialized = true;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function initCountdown(section) {
      const countdown = section.querySelector('[data-soyes-countdown]');

      if (!countdown) {
        return;
      }

      // ──────────────────────────────────────────────────────────
      //  DROP_DATE — Launch-Datum/Uhrzeit hier anpassen (ISO 8601)
      //  Wird als Fallback genutzt, wenn kein Wert im Theme-Editor
      //  gesetzt ist (Themes → Anpassen → "Launch date and time").
      // ──────────────────────────────────────────────────────────
      const DROP_DATE = '2026-07-01T18:00:00+02:00'; // <-- hier anpassen

      const configuredTarget = new Date(section.dataset.launchTarget);
      const target = Number.isNaN(configuredTarget.getTime()) ? new Date(DROP_DATE) : configuredTarget;

      const parts = {
        days: countdown.querySelector('[data-countdown-days]'),
        hours: countdown.querySelector('[data-countdown-hours]'),
        minutes: countdown.querySelector('[data-countdown-minutes]'),
        seconds: countdown.querySelector('[data-countdown-seconds]'),
      };

      let isLive = false;

      function tick() {
        const diff = Math.max(0, target.getTime() - Date.now());

        if (diff === 0 && !isLive) {
          isLive = true;
          countdown.innerHTML = '<span class="soyes-countdown__live">LIVE NOW</span>';
          return;
        }

        if (isLive) {
          return;
        }

        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);

        parts.days.textContent = pad(days);
        parts.hours.textContent = pad(hours);
        parts.minutes.textContent = pad(minutes);
        parts.seconds.textContent = pad(seconds);
      }

      tick();
      window.setInterval(tick, 1000);
    }

    function initCarousel(section) {
      const carousel = section.querySelector('[data-soyes-carousel]');

      if (!carousel) {
        return;
      }

      const viewport = carousel.querySelector('[data-carousel-viewport]');
      const track = carousel.querySelector('[data-carousel-track]');
      const slides = Array.from(track.children);
      const previousButton = carousel.querySelector('[data-carousel-prev]');
      const nextButton = carousel.querySelector('[data-carousel-next]');
      const dots = Array.from(section.querySelectorAll('[data-carousel-dot]'));
      let currentIndex = 0;
      let startX = 0;

      function getGap() {
        return parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
      }

      function getMaxIndex() {
        const slide = slides[0];

        if (!slide) {
          return 0;
        }

        const gap = getGap();
        const slideWidth = slide.getBoundingClientRect().width;
        const visibleSlides = Math.max(1, Math.floor((viewport.clientWidth + gap) / (slideWidth + gap)));

        return Math.max(0, slides.length - visibleSlides);
      }

      function update() {
        const slide = slides[0];

        if (!slide) {
          return;
        }

        const gap = getGap();
        const maxIndex = getMaxIndex();
        const slideWidth = slide.getBoundingClientRect().width + gap;
        currentIndex = Math.min(Math.max(currentIndex, 0), maxIndex);
        track.style.transform = `translateX(${-currentIndex * slideWidth}px)`;

        previousButton.disabled = currentIndex === 0;
        nextButton.disabled = currentIndex === maxIndex;
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === currentIndex);
          dot.hidden = index > maxIndex;
        });
      }

      previousButton.addEventListener('click', () => {
        currentIndex -= 1;
        update();
      });

      nextButton.addEventListener('click', () => {
        currentIndex += 1;
        update();
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          currentIndex = index;
          update();
        });
      });

      track.addEventListener(
        'touchstart',
        (event) => {
          startX = event.touches[0].clientX;
        },
        { passive: true }
      );

      track.addEventListener(
        'touchend',
        (event) => {
          const distance = event.changedTouches[0].clientX - startX;

          if (distance < -40) {
            currentIndex += 1;
          } else if (distance > 40) {
            currentIndex -= 1;
          }

          update();
        },
        { passive: true }
      );

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(viewport);
      } else {
        window.addEventListener('resize', update);
      }

      update();
    }

    function init(root = document) {
      root.querySelectorAll('[data-soyes-launch]:not([data-soyes-launch-ready])').forEach((section) => {
        section.dataset.soyesLaunchReady = 'true';
        initCountdown(section);
        initCarousel(section);
      });
    }

    document.addEventListener('DOMContentLoaded', () => init(document));
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    init(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soyes-preview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initSprev(root) {
      root.querySelectorAll('[data-sprev-arrow]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const id = btn.dataset.sprevTarget;
          const track = document.getElementById('sprev-' + id);
          if (!track) return;
          const slide = track.querySelector('[data-sprev-slide]');
          if (!slide) return;
          const dir = parseInt(btn.dataset.sprevArrow, 10);
          track.scrollBy({ left: slide.offsetWidth * dir, behavior: 'smooth' });
        });
      });

      document.querySelectorAll('.sprev__track').forEach((track) => {
        const id = track.id.replace('sprev-', '');
        const dotsEl = document.getElementById('sprev-dots-' + id);
        if (!dotsEl) return;
        const dots = Array.from(dotsEl.querySelectorAll('[data-sprev-dot]'));
        const slides = Array.from(track.querySelectorAll('[data-sprev-slide]'));
        if (!dots.length || !slides.length) return;

        track.addEventListener('scroll', () => {
          const slideW = slides[0].offsetWidth || 1;
          const index = Math.round(track.scrollLeft / slideW) % dots.length;
          dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
        }, { passive: true });
      });
    }

    document.addEventListener('DOMContentLoaded', () => initSprev(document));
    document.addEventListener('shopify:section:load', (e) => initSprev(e.target));
    initSprev(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
